module.exports = __webpack_public_path__ + "static/img/1069.fbd8d78.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/1069.jpg
// module id = 251
// module chunks = 0